export default "__VITE_ASSET__CPM5sjUa__"